import { render } from "./anonimMessage.vue?vue&type=template&id=36c0dfba&scoped=true"
import script from "./anonimMessage.vue?vue&type=script&lang=js"
export * from "./anonimMessage.vue?vue&type=script&lang=js"

import "./anonimMessage.vue?vue&type=style&index=0&id=36c0dfba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c0dfba"]])

export default __exports__